export default __webpack_public_path__ + "static/bb3-372c3e9080924e26df369d35b0c6a280.jpeg";